module.exports = __webpack_public_path__ + "static/media/9001.1f1a7a7c.jpg";